import { render, staticRenderFns } from "./si_arrowsLeft.vue?vue&type=template&id=a461380e&scoped=true&"
import script from "./si_arrowsLeft.vue?vue&type=script&lang=js&"
export * from "./si_arrowsLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461380e",
  null
  
)

export default component.exports